import axios from "axios";

export default axios.create({
  // baseURL: "http://192.168.1.22:6060",
  baseURL: "https://navoros.com:443",
  // headers: { "Content-Type": "application/json; charset=utf-8" },
});
